// src/services/authService.js

import { auth, db } from "./firebaseConfig";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";

const ADMIN_CODE = "SamratHEFA";

// 🔐 REGISTER
export async function registerWithEmail({
  displayName,
  email,
  password,
  adminCode,
}) {
  const { user } = await createUserWithEmailAndPassword(
    auth,
    email,
    password
  );

  await updateProfile(user, { displayName });

  // send verification email
  await sendEmailVerification(user);

  const role = adminCode === ADMIN_CODE ? "admin" : "user";

  await setDoc(doc(db, "users", user.uid), {
    uid: user.uid,
    displayName,
    email,
    role,
    createdAt: Date.now(),
  });

  return { ok: true };
}

// 🔐 LOGIN
export async function loginWithEmail(email, password) {
  const userCredential = await signInWithEmailAndPassword(
    auth,
    email,
    password
  );

  // 🔥 Force refresh user data from Firebase server
  await userCredential.user.reload();

  const refreshedUser = auth.currentUser;

 

  return userCredential;
}


// 🔁 FORGOT PASSWORD
export async function resetPassword(email) {
  if (!email) {
    throw new Error("Email is required.");
  }

  return await sendPasswordResetEmail(auth, email);
}

// 🎯 GET USER ROLE
export async function getUserRole(uid) {
  const docRef = doc(db, "users", uid);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data().role;
  }

  return null;
}
